import axios from 'axios';

const api = axios.create({
  baseURL: 'https://dex-api.qie.systems/', // need to figure out about this url , what the use cases of this url where this url is using
  withCredentials: false,
});

export default api;
